import * as React from "react";
import { AlertCircle } from "lucide-react";

import { cn } from "../lib/utils";
import { Label } from "./ui/label";

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  title?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, error, title, required, name, ...props }, ref) => {
    const textareaId = name || `textarea-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className="space-y-2">
        {title && (
          <Label
            htmlFor={textareaId}
            className={cn(
              "text-sm font-medium text-muted-foreground",
              error && "text-red-600 dark:text-red-400"
            )}
          >
            {title}
            {required && <span className="text-red-500 dark:text-red-400 ml-1">*</span>}
          </Label>
        )}
        <textarea
          id={textareaId}
          name={name}
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-border bg-background text-foreground px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-red-300 dark:border-red-800 focus-visible:ring-red-500",
            className
          )}
          ref={ref}
          required={required}
          {...props}
        />
        {error && (
          <div className="flex items-center gap-2 text-sm text-red-600 dark:text-red-400">
            <AlertCircle className="h-4 w-4" />
            <span>{error}</span>
          </div>
        )}
      </div>
    );
  }
);
TextArea.displayName = "TextArea";

export { TextArea };
